import { MapProvider } from "./types";
import { number, object, ObjectSchema, string, mixed, boolean } from "yup";

type MarkerIcon = "house" | "pin";

export type OptionsMarker = {
  lat: number;
  lng: number;
  icon?: MarkerIcon;
  addressLabel?: string;
};

type DistanceUnit = "metric" | "imperial";

export type Options = {
  lat: number;
  lng: number;
  zoom?: number;
  pitch?: number;
  bearing?: number;
  distanceUnit?: DistanceUnit;
  marker?: OptionsMarker;
  cooperativeGestures?: boolean;
  mapProvider?: MapProvider;
};

export const schema: ObjectSchema<Options> = object({
  lat: number()
    .min(-90, "Must be a valid latitude.")
    .max(90, "Must be a valid latitude.")
    .required(),
  lng: number()
    .min(-180, "Must be a valid longitude.")
    .max(180, "Must be a valid longitude.")
    .required(),
  zoom: number().optional(),
  pitch: number().optional(),
  bearing: number().optional(),
  distanceUnit: mixed<DistanceUnit>().oneOf(["metric", "imperial"]).optional(),
  marker: object({
    lat: number()
      .min(-90, "Must be a valid latitude.")
      .max(90, "Must be a valid latitude.")
      .required(),
    lng: number()
      .min(-180, "Must be a valid longitude.")
      .max(180, "Must be a valid longitude.")
      .required(),
    icon: mixed<MarkerIcon>().oneOf(["house", "pin"]).optional(),
    addressLabel: string().optional(),
  }).default(undefined),
  cooperativeGestures: boolean().optional(),
  mapProvider: mixed<MapProvider>().optional(),
}).noUnknown(true);

export const validateOptions = (options: Options) =>
  schema.validate(options, { abortEarly: false });
